module.exports = __webpack_public_path__ + "static/media/Football Referee.47885085.jpg";